export type PagePreview = {
  id: string;
  alt: string;
  src: string;
};

export const pagePreviews: PagePreview[] = [
  {
    id: 'hangeul',
    alt: 'Page intérieure : comprendre le 한글 (Hangeul), l’alphabet qui change tout',
    src: 'https://cdn.magicpatterns.com/uploads/tHi5WN2WRFekeTJkUdM4Pz/Screenshot_20260911_094600_Drive.jpg',
  },
  {
    id: 'consonnes',
    alt: 'Page intérieure : les 14 consonnes de base et la forme de chaque lettre',
    src: 'https://cdn.magicpatterns.com/uploads/q8ikRRGschwFszJdDyqiHk/Screenshot_20260911_094208_Drive.jpg',
  },
  {
    id: 'sons',
    alt: 'Page intérieure : le guide des sons, du français au coréen',
    src: 'https://cdn.magicpatterns.com/uploads/sxkFbsxVDBD6rPzaDysnNB/Screenshot_20260911_094234_Drive.jpg',
  },
  {
    id: 'kpop',
    alt: 'Page intérieure : vocabulaire K-Pop essentiel',
    src: 'https://cdn.magicpatterns.com/uploads/5uQTxif1GjVDxYiJEMC5Ku/Screenshot_20260911_094331_Drive.jpg',
  },
  {
    id: 'amour',
    alt: 'Page intérieure : 5 phrases d’amour essentielles des K-Dramas',
    src: 'https://cdn.magicpatterns.com/uploads/pW39zjqj8nxbNHq4e12oUU/Screenshot_20260911_094410_Drive.jpg',
  },
  {
    id: 'gastronomie',
    alt: 'Page intérieure : alimentation et gastronomie, manger comme dans un K-Drama',
    src: 'https://cdn.magicpatterns.com/uploads/7TPudDsorPrxHeYNK7Wnss/Screenshot_20260911_094439_Drive.jpg',
  },
  {
    id: 'culture',
    alt: 'Page intérieure : apprendre la culture pour maîtriser la langue',
    src: 'https://cdn.magicpatterns.com/uploads/hrQMm4pu8wfmTurTVaQD1H/Screenshot_20260911_094648_Drive.jpg',
  },
];
